import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './node-style.css'

const propTypes = {
    nodeData: PropTypes.object.isRequired
}

const NodeChart = ({ nodeData }) => {
    if (!nodeData) return null

    const childCount = nodeData?.childCount ?? 0

    return (
        <Fragment>
            <div className="nodeBox">
                <div className="position">
                    {nodeData?.position_name || '-'}
                </div>

                {childCount > 0 && (
                    <div className="child-count">
                        {childCount}
                    </div>
                )}
            </div>
        </Fragment>
    )
}

NodeChart.propTypes = propTypes
export default NodeChart